/**
 * Иконки, нужные только этому приложению.
 *
 * Общий набор — `IconCollection` из `@aspid/ui`; здесь лежит то, что на момент
 * сведения (AF-19) встречалось лишь у analyst, и осознанные оверрайды общих имён.
 *
 * **Добавить иконку — одна строка здесь.** Правок в пакете не требуется: если
 * иконка понадобится второму приложению, тогда и переедет в общий набор.
 */

import {
  faChartLine as chartBar,
  faCircleCheck as circleCheck,
  faCircleXmark as circleXmark,
  faCopy as copy,
  faCubes as cubes,
  faEnvelope as envelope,
  faFileLines as fileLines,
  faFlask as flask,
  faForwardStep as forwardStep,
  faHourglass as hourglass,
  faPause as pause,
  faShieldCheck as shield,
  faShieldCheck as shieldCheck,
  faSpinner as spinner,
  faTriangleExclamation as triangleExclamation,
  faWrench as wrench,
} from '@fortawesome/pro-light-svg-icons';

export const appIcons = {
  chartBar,
  circleCheck,
  circleXmark,
  copy,
  cubes,
  envelope,
  fileLines,
  flask,
  forwardStep,
  hourglass,
  pause,
  shield,
  shieldCheck,
  spinner,
  triangleExclamation,
  wrench,
};
